import React from 'react'
import { Tooltip } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'

interface InfoLabelProps {
  label: string
  infoText?: string
}

const InfoToolTipLabel: React.FC<InfoLabelProps> = ({ label, infoText }) => (
  <div className="flex flex-row gap-1">
    <div className="z-1 text-base pointer-events-none transition-all duration-200 ease-linear text-black font-barlow font-medium ml-0 mb-1">
      {label}
    </div>
    {infoText && (
      <div className="mb-1 text-[#4386d9]">
        <Tooltip title={infoText}>
          <InfoCircleOutlined />
        </Tooltip>
      </div>
    )}
  </div>
)

export default InfoToolTipLabel